import React, {useRef, useState} from "react";
import ButtonText from "../../connectui/component/input/button/ButtonText";
import OutlinedButtonBase from "../../connectui/component/input/button/base/OutlinedButtonBase";
import ContextMenu from "../../connectui/component/input/context/ContextMenu";
import ContextMenuItem from "../../connectui/component/input/context/ContextMenuItem";
import {ReactComponent as SettingsIcon} from "connectui/icons/settings-tune.svg";
import {ReactComponent as DeleteIcon} from "connectui/icons/trash.svg";
import {ReactComponent as DuplicateIcon} from "connectui/icons/copy.svg";
import {ReactComponent as ChevronRightIcon} from "connectui/icons/chevron-right.svg";
import SvgIcon from "connectui/component/display/SvgIcon";

const ContextMenuExample = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const optionClicked = useRef(null);
  const [optionsAnchorEl, setOptionsAnchorEl] = useState(null);
  const [subMenuPosition, setSubMenuPosition] = useState({top: 0, left: 0});

  const menuItems = [
    {
      label: "Edit",
      subLabel: "Sub label",
      icon: SettingsIcon,
      onClick: () => {
        alert("Edit clicked");
        closeMenu();
      },
    },
    {
      label: "Delete",
      icon: DeleteIcon,
      onClick: () => {
        alert("Delete clicked");
        closeMenu();
      },
    },
    {
      Component: ({label}) => (
        <ContextMenuItem
          label={label}
          icon={DuplicateIcon}
          onClick={() => {
            alert("Custom item clicked");
            closeMenu();
          }}
        />
      ),
      label: "Custom Item",
    },
    {
      Component: ({label}) => (
        <ContextMenuItem
          label={label}
          actions={
            <SvgIcon
              sx={{
                width: "7px",
                height: "7px",
                color: "#a4a7ae",
                marginRight: "-4px",
              }}
              component={ChevronRightIcon}
            />
          }
          onClick={(e) => {
            const rect = e.currentTarget.getBoundingClientRect();
            setSubMenuPosition({top: rect.top, left: rect.right});
            setOptionsAnchorEl(e.currentTarget);
          }}
        />
      ),
      label: "Open options",
    },
  ];

  const optionItems = [
    {
      label: "Sub item",
      onMouseDown: () => {
        optionClicked.current = true;
      },
      onClick: () => {
        alert("I'm an option");
        closeSubMenu();
        closeMenu();
      },
    },
  ];

  const openMenu = (event) => setAnchorEl(event.currentTarget);
  const closeMenu = () => {
    if (optionClicked.current) return;
    setAnchorEl(null);
    setOptionsAnchorEl(null);
  };
  const closeSubMenu = () => {
    optionClicked.current = false;
    setOptionsAnchorEl(null);
  };

  return (
    <div>
      <h3>Context Menu Example</h3>

      <ButtonText
        buttonBase={OutlinedButtonBase}
        typographyVariant="textSM"
        weight="semibold"
        onClick={openMenu}
      >
        Open Context Menu
      </ButtonText>
      <ContextMenu
        menuItems={menuItems}
        open={!!anchorEl}
        onClose={closeMenu}
        anchorEl={anchorEl}
      />
      <ContextMenu
        menuItems={optionItems}
        open={!!optionsAnchorEl}
        onClose={closeSubMenu}
        anchorEl={optionsAnchorEl}
        modalProps={{customPosition: subMenuPosition}}
      />
    </div>
  );
};

export default ContextMenuExample;
